<template>
    <project-step-container
            prev-to="be_go_broad_to_go_narrow_13"
            @next-click="updateProject"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            :next-disabled="disabled()"
    >
        <b-row>
            <b-col cols="12" class="main-text " tabindex="0">
                {{getMessage(14, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(14, 'firstIdea')}}</label>
                <input id="first-thing" type="text" v-model="form.firstIdea"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(14, 'secondIdea')}}</label>
                <input id="second-thing" type="text" v-model="form.secondIdea"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(14, 'thirdIdea')}}</label>
                <input id="third-thing" type="text" v-model="form.thirdIdea"/>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import Steps from "../Utils/steps";
    import {ConflictSyn, Project, Storage} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    export default {
        name: "GoBroadToGoNarrow14",
        components: {ProjectStepContainer},
        props: ["items"],

        data() {
            return {
                step: Steps.FORM_TOP_IDEAS,
                urlNextProject: 'be_go_broad_to_go_narrow_15',
                form: {
                    firstIdea: "",
                    secondIdea: "",
                    thirdIdea: ""
                },

            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                const form = this.form
                this.$router.push({name: this.urlNextProject, params: {index, items:form}})
            },
            disabled() {
                if (this.form.firstIdea === '' || this.form.secondIdea === '' || this.form.thirdIdea === '') {
                    return true
                }
            }
        }
    }
</script>

